import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 14h14v-9h-14v16","key":"svg-0"}]]

const IconFlag2 = createReactComponent('outline', 'flag-2', 'Flag2', __iconNode);

export default IconFlag2;